// @flow

import ToggleReceptor from './ToggleReceptor';

export default class AddressToggleReceptor extends ToggleReceptor {
  /**
   * Instantiate the address toggle receptor component
   *
   * @param el
   */
  bind(el: HTMLElement) {
    super.bind(el);

    if (this.el.classList.contains(this.class)) {
      this.handleHide();
    }
  }

  /**
   * @inheritDoc
   */
  handleShow(): void {
    super.handleShow();
    this.el.querySelectorAll('input').forEach((element: Element) => {
      element.removeAttribute('disabled');
    });
  }

  /**
   * @inheritDoc
   */
  handleHide() {
    super.handleHide();
    this.el.querySelectorAll('input').forEach((element: Element) => {
      element.setAttribute('disabled', 'true');
    });
  }
}
